import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Link, Copy, ExternalLink } from 'lucide-react';

interface BookingLinkCardProps {
  bookingUrl: string;
  onCopy: () => void;
  className?: string;
}

export const BookingLinkCard: React.FC<BookingLinkCardProps> = ({
  bookingUrl,
  onCopy,
  className,
}) => {
  if (!bookingUrl) return null;

  return (
    <Card className={`border-teal-200 bg-gradient-to-r from-teal-50 to-white ${className || ''}`}>
      <CardContent className="py-4">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex min-w-0 flex-1 items-center gap-3">
            <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-teal-100">
              <Link className="h-5 w-5 text-teal-600" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-slate-900">Your Public Booking Link</p>
              <p className="truncate font-mono text-sm text-teal-600">{bookingUrl}</p>
            </div>
          </div>
          <div className="flex flex-shrink-0 items-center gap-2">
            <Button variant="outline" size="sm" onClick={onCopy}>
              <Copy className="mr-1 h-4 w-4" />
              Copy
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => window.open(bookingUrl, '_blank')}
            >
              <ExternalLink className="mr-1 h-4 w-4" />
              Preview
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

